module.exports = __webpack_public_path__ + "img/clients1-1680.03fd89d.png";